module.exports = __webpack_public_path__ + "img/dial-max.56632c37.svg";